/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1DocumentDataStatusString } from '../../entities/v1/DocumentDataStatusString'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1DocumentDataStatusStringSchema = z.enum(['idle', 'approved', 'declined', 'unknown']) as unknown as ToZod<V1DocumentDataStatusString>